import { Injectable } from '@angular/core';
import { RequestOptions, Response } from '@angular/http';

import { AuthHttp } from '../../../common/index';
import { AppSettings } from '../../../settings/index';

@Injectable()
export class GoogleGeocodeService {
    constructor(private http: AuthHttp) { }
    
    get(url) {
        return this.http.getNoAuth(url)
            .map((response: Response) => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/master/op/google.geocode.service.ts